export const API_URL = "https://bugify.techtsy.com/";
